import {
    Component,
    ojs,
    app,
    state,
    v,
    each,
    payload,
} from "modular-openscriptjs";
import {
    monetary,
    either,
    cleanDispose,
    isMobile,
    empty,
    eParse,
    updateStateValue,
    inform,
    formatThousand,
    redirect,
    getProductAvailabilityWindow,
} from "../../helpers";
import SearchResultProductView from "./SearchResultProductView";
import { tool } from "../../fotastart";
import ViewProductCanvas from "../Offcanvas/ViewProductCanvas";
import ViewProductModal from "../Modals/ViewProductModal";
import ExtraFeaturesModal from "../Modals/ExtraFeaturesModal";
import { api, uc, dc, STRINGS } from "../../declarations";
import { routes } from "../../backendRoutes";
import Spinner, { SmallSpinner } from "../Blocks/Spinner";
import CheckYesno from "../Blocks/CheckYesno";
import { $e } from "../../ojs.events";
import {
    shareLink,
    productShareUrl,
    isShareableProduct,
} from "../../shareLink";

const h = app("h");
const broker = app("broker");

ojs(
    SearchResultProductView,
    ViewProductCanvas,
    ViewProductModal,
    ExtraFeaturesModal,
    SmallSpinner,
    CheckYesno,
    Spinner,
);

export default class ViewProduct extends Component {
    holder = null;
    currentProductId = null;

    activeImage = state("");
    globalQuantity = state(1);

    // State for extras quantities: { extraId: quantity }
    extraQuantities = state({});

    // State for selected features: { featureId: [selectedOptions] }
    selectedFeatures = state({});

    // State for selected features on extras: { extraId: { featureId: [selectedOptions] } }
    selectedExtraFeatures = state({});

    fetchingProduct = state(false);
    cartItem = state(null);
    relatedProducts = state([]);
    fetchingRelated = state(false);

    $$product = {
        needs: {
            display: (ed, event) => {
                this.showProduct(ed, event);
            },
        },
        display: {
            need: {
                close: (ed, event) => this.closeView(),
            },
        },
    };

    closeView() {
        if (this.holder) {
            cleanDispose(this.holder);
        }
    }

    async fetchProduct(productId, productState) {
        let res = await api.get(`/products/${productId}`);

        if (res && res.data && res.data.product) {
            productState.value = res.data.product;
            if (
                productState.value.images &&
                productState.value.images.length > 0
            ) {
                this.activeImage.value = productState.value.images[0].path;
            }
        }

        this.getRelatedProducts(productId);

        this.fetchingProduct.value = false;
    }

    async getRelatedProducts(productId) {
        this.fetchingRelated.value = true;
        this.relatedProducts.value = [];
        try {
            let res = await api.get(`/products/${productId}/related`);
            if (res && res.data && res.data.products) {
                this.relatedProducts.value = res.data.products;
            }
        } catch (e) {
            console.error("Failed to load related products", e);
        } finally {
            this.fetchingRelated.value = false;
        }
    }

    async toggleBookmark(pState) {
        const product = pState.value;
        const bookmarked = product.currently_bookmarked;
        const url = `/customers/products/${product.id}/bookmark`;

        try {
            let res;
            if (bookmarked) {
                res = await api.delete(url);
                if (res) {
                    inform(res.message || "Bookmark removed", STRINGS.SUCCESS);
                    pState.value = {
                        ...product,
                        currently_bookmarked: false,
                        save_count: Math.max(0, (product.save_count || 0) - 1),
                    };
                }
            } else {
                res = await api.post(url);
                if (res) {
                    inform(
                        res.message || "Product bookmarked",
                        STRINGS.SUCCESS,
                    );
                    pState.value = {
                        ...product,
                        currently_bookmarked: true,
                        save_count: (product.save_count || 0) + 1,
                    };
                }
            }
        } catch (e) {
            inform(
                e.response?.data?.message || "Failed to update bookmark",
                STRINGS.ERROR,
            );
        }
    }

    renderForm(productState, holder) {
        return v(productState, (pState) => {
            const product = productState.value;

            if (
                this.activeImage.value === "" &&
                product.images &&
                product.images.length > 0
            ) {
                this.activeImage.value = product.images[0].path;
            }

            const userCurrency = dc.userCurrency;

            return h.div(
                { class: "view-product-container mb-5 pb-5" },
                either(!isMobile(), { class: "position-relative" }),

                // Close Button
                h.button(
                    {
                        class: "btn border rounded-circle position-absolute d-flex align-items-center justify-content-center",
                        style: "top: 25px; right: 25px; width: 40px; height: 40px; background: rgba(255,255,255,0.6); backdrop-filter: blur(4px); z-index: 1000;",
                        data_bs_dismiss: holder,
                    },
                    h.i({ class: "bi bi-x-lg text-dark fw-bold" }),
                ),

                // Share Button - public products only (a product with a
                // user_id is private and must not be shared).
                either(isShareableProduct(product), () =>
                    h.button(
                        {
                            type: "button",
                            aria_label: "Share",
                            class: "btn border rounded-circle position-absolute d-flex align-items-center justify-content-center",
                            style: "top: 25px; right: 75px; width: 40px; height: 40px; background: rgba(255,255,255,0.6); backdrop-filter: blur(4px); z-index: 1000;",
                            listeners: {
                                click: () =>
                                    shareLink({
                                        title: product.name,
                                        text: product.company?.name
                                            ? `${product.name} - ${product.company.name} on Carata`
                                            : `${product.name} on Carata`,
                                        url: productShareUrl(product),
                                    }),
                            },
                        },
                        h.i({ class: "bi bi-share text-dark fw-bold" }),
                    ),
                ),

                // Main Product Section
                // Image Section
                h.div(
                    { class: "col-12" },
                    h.call(() => {
                        const p = product;

                        let images = p.images || [];
                        return either(images.length > 0, () => [
                            h.div(
                                {
                                    class: "rounded-4 overflow-hidden shadow-sm mb-3 bg-light",
                                },
                                v(
                                    this.activeImage,
                                    (img) =>
                                        h.img({
                                            src: img,
                                            class: "img-fluid w-100",
                                            style: "object-fit: contain;",
                                            alt: p.name,
                                        }),

                                    {
                                        class: "d-block",
                                        c_attr: {
                                            class: "d-block",
                                        },
                                    },
                                ),
                            ),
                            // Thumbnails
                            either(images.length > 1, () =>
                                h.div(
                                    {
                                        class: "d-flex gap-2 overflow-x-auto pb-2 px-4 scrollbar-hidden",
                                        style: "scrollbar-width: none;",
                                    },
                                    each(images, (img) =>
                                        h.div(
                                            {
                                                class: "rounded-3 overflow-hidden border cursor-pointer flex-shrink-0",
                                                style: v(
                                                    this.activeImage,
                                                    (active) =>
                                                        `width: 70px; height: 70px; border-width: 2px !important; border-color: ${active === img.path ? "#0d6efd" : "#dee2e6"} !important; transition: all 0.2s;`,
                                                ),
                                                listeners: {
                                                    click: () =>
                                                        (this.activeImage.value =
                                                            img.path),
                                                },
                                            },
                                            h.img({
                                                src: img.path,
                                                class: "w-100 h-100 object-fit-cover",
                                            }),
                                        ),
                                    ),
                                ),
                            ),
                        ]);
                    }),
                ),

                h.call(() => {
                    const p = product;
                    return h.div(
                        {
                            class: "product-main-card bg-white p-4 mb-4 border-0",
                        },
                        h.div(
                            { class: "row g-4" },

                            // Content Section
                            h.div(
                                { class: "col-12 d-flex flex-column" },
                                h.div(
                                    {
                                        class: "d-flex justify-content-between align-items-center mb-1 w-100",
                                    },
                                    h.h2(
                                        {
                                            class: "fw-bold mb-0 text-dark",
                                            style: "font-size: 1.5rem;",
                                        },
                                        p.name,
                                    ),
                                    either(
                                        p.user_id && p.user_id == gc?.user?.id,
                                        null,
                                        () =>
                                            h.div(
                                                {
                                                    class: "d-flex align-items-center gap-1",
                                                },
                                                h.button(
                                                    {
                                                        class: "btn btn-link p-0 text-decoration-none border-0",
                                                        listeners: {
                                                            click: () =>
                                                                this.toggleBookmark(
                                                                    pState,
                                                                ),
                                                        },
                                                        style: "box-shadow: none;",
                                                    },
                                                    h.i({
                                                        class: p.currently_bookmarked
                                                            ? "bi bi-bookmark-fill text-primary"
                                                            : "bi bi-bookmark text-secondary",
                                                        style: "font-size: 1.5rem;",
                                                    }),
                                                ),
                                                either(p.save_count > 0, () =>
                                                    h.small(
                                                        {
                                                            class: "text-muted small fw-semibold",
                                                            style: "font-size: 0.95rem; margin-left: 2px;",
                                                        },
                                                        formatThousand(
                                                            p.save_count || 0,
                                                        ),
                                                    ),
                                                ),
                                            ),
                                    ),
                                ),
                                h.div(
                                    { class: "d-flex align-items-center mb-3" },
                                    h.span(
                                        { class: "text-muted me-2 small" },
                                        "Sold by:",
                                    ),
                                    h.span(
                                        { class: "fw-bold text-primary small" },
                                        either(
                                            p.company?.id ||
                                                p.affiliated_company?.id,
                                            {
                                                listeners: {
                                                    click: () => {
                                                        app("router").to(
                                                            "business.view-profile",
                                                            {
                                                                businessId:
                                                                    p.company
                                                                        ?.id ||
                                                                    p
                                                                        .affiliated_company
                                                                        ?.id,
                                                            },
                                                        );

                                                        this.closeProductView()
                                                    },
                                                },
                                            },
                                        ),
                                        p.company?.name ||
                                            p.affiliated_company?.name ||
                                            "Any Nearby Shop",
                                    ),
                                ),
                                h.div(
                                    {
                                        class: "d-flex justify-content-between align-items-center mb-2 flex-wrap gap-2",
                                    },
                                    h.div(
                                        {
                                            class: "d-flex align-items-center flex-wrap gap-2",
                                        },
                                        v(this.selectedFeatures, () =>
                                            v(this.globalQuantity, () => {
                                                const pricing =
                                                    this.computeDisplayPricing(
                                                        p,
                                                    );
                                                return either(
                                                    pricing.hasDiscount,
                                                    () => [
                                                        h.h3(
                                                            {
                                                                class: "text-dark fw-bold mb-0",
                                                            },
                                                            monetary(
                                                                pricing.discountedPrice,
                                                                userCurrency,
                                                            ),
                                                        ),
                                                        h.span(
                                                            {
                                                                class: "text-muted text-decoration-line-through me-2",
                                                                style: "font-size: 1rem;",
                                                            },
                                                            monetary(
                                                                pricing.displayPrice,
                                                                userCurrency,
                                                            ),
                                                        ),
                                                        h.span(
                                                            {
                                                                class: "badge bg-danger rounded-pill px-2 py-1 d-inline-flex align-items-center gap-1",
                                                            },
                                                            h.i({
                                                                class: "bi bi-tag-fill",
                                                            }),
                                                            `-${pricing.discountPercent}%`,
                                                        ),
                                                    ],
                                                    () =>
                                                        h.h3(
                                                            {
                                                                class: "text-dark fw-bold mb-0",
                                                            },
                                                            monetary(
                                                                pricing.displayPrice,
                                                                userCurrency,
                                                            ),
                                                        ),
                                                );
                                            }),
                                        ),
                                    ),
                                    h.call(() => {
                                        if (!p.has_stock_information)
                                            return null;
                                        if (p.quantity <= 0) {
                                            return h.span(
                                                {
                                                    class: "badge bg-danger-subtle text-danger rounded px-2 py-1 small fw-bold",
                                                },
                                                "Out of Stock",
                                            );
                                        }
                                        if (p.quantity <= 50) {
                                            return h.span(
                                                {
                                                    class: "badge bg-warning-subtle text-warning-emphasis rounded px-2 py-1 small fw-bold",
                                                },
                                                `${p.quantity} left`,
                                            );
                                        }
                                        return null;
                                    }),
                                ),

                                v(this.selectedFeatures, () =>
                                    v(this.globalQuantity, () => {
                                        const pricing =
                                            this.computeDisplayPricing(p);
                                        return either(
                                            pricing.hasDiscount &&
                                                pricing.activeDeal,
                                            () =>
                                                h.div(
                                                    {
                                                        class: "small text-danger fw-semibold mb-2 d-flex align-items-center gap-1",
                                                    },
                                                    h.i({
                                                        class: "bi bi-stars",
                                                    }),
                                                    `Deal: ${pricing.activeDeal?.name}` +
                                                        (pricing.discountPercent
                                                            ? ` — ${pricing.discountPercent}% off`
                                                            : ""),
                                                ),
                                        );
                                    }),
                                ),

                                // Price transparency note: always shown, regardless of
                                // packaging - the displayed price above already has
                                // Carata's commission markup baked in.
                                h.span(
                                    {
                                        class: "text-muted d-block mb-2",
                                        style: "font-size: 0.75rem;",
                                    },
                                    "(price includes Carata's markup)",
                                ),

                                either(!(p.package_price > 0), null, () =>
                                    h.div(
                                        {
                                            class: "d-flex align-items-center flex-wrap gap-1 mb-3",
                                        },
                                        h.span(
                                            {
                                                class: "text-dark fw-semibold small",
                                            },
                                            `+ ${monetary(p.package_price, userCurrency)} for packaging`,
                                        ),
                                    ),
                                ),

                                // Description (Now below Price)
                                h.p(
                                    {
                                        class: "text-muted mb-4",
                                        style: "font-size: 0.95rem; line-height: 1.6;",
                                    },
                                    p.description,
                                ),

                                v(this.fetchingProduct, (fetchState) => {
                                    if (fetchState.value) {
                                        return h.Spinner();
                                    }
                                }),

                                // Features (Vertical List)
                                h.div(
                                    { class: "features-list mb-4" },
                                    either(empty(p.features), {
                                        class: "d-none",
                                    }),

                                    each(p.features ?? [], (feature) =>
                                        h.div(
                                            {
                                                class: "mb-4 pb-3 border-bottom border-light",
                                            },
                                            h.div(
                                                {
                                                    class: "d-flex justify-content-between align-items-center mb-1",
                                                },
                                                h.span(
                                                    {
                                                        class: "fw-bold text-dark fs-5",
                                                    },
                                                    feature.name,
                                                ),
                                                either(
                                                    feature.is_required,
                                                    () =>
                                                        h.span(
                                                            {
                                                                class: "badge bg-danger-subtle text-danger small rounded-pill px-2.5",
                                                            },
                                                            "Required",
                                                        ),
                                                    () =>
                                                        h.span(
                                                            {
                                                                class: "badge bg-light text-dark small rounded-pill px-2.5",
                                                            },
                                                            "Optional",
                                                        ),
                                                ),
                                            ),
                                            this.getChoiceTypeLabel(
                                                feature.choice_type,
                                            ),
                                            h.div(
                                                {
                                                    class: "options-container mt-2",
                                                },
                                                this.renderFeatureInput(
                                                    feature,
                                                    this.selectedFeatures,
                                                    userCurrency,
                                                ),
                                            ),
                                        ),
                                    ),
                                ),

                                // Extras (Vertical List with Logic)
                                h.div(
                                    { class: "extras-list mb-4" },
                                    either(empty(p.extras), {
                                        class: "d-none",
                                    }),
                                    h.label(
                                        {
                                            class: "fw-bold text-dark mb-3 d-block",
                                        },
                                        "Extras",
                                    ),
                                    each(p.extras ?? [], (extra) =>
                                        h.div(
                                            {
                                                class: "d-flex align-items-center justify-content-between py-3",
                                            },
                                            h.div(
                                                h.div(
                                                    {
                                                        class: "fw-medium small text-dark fs-6",
                                                    },
                                                    extra.name,
                                                ),
                                                h.div(
                                                    {
                                                        class: "text-dark small",
                                                    },
                                                    `+ ${monetary(extra.final_price, userCurrency)}`,
                                                ),
                                            ),
                                            h.div(
                                                { class: "extra-action ms-3" },
                                                v(
                                                    this.extraQuantities,
                                                    (quantities) => {
                                                        const qty =
                                                            quantities[
                                                                extra.id
                                                            ] || 0;
                                                        return either(
                                                            qty > 0,
                                                            () =>
                                                                h.div(
                                                                    {
                                                                        class: "d-flex align-items-center border rounded-pill bg-light",
                                                                    },
                                                                    h.button(
                                                                        {
                                                                            class: "btn btn-link text-dark p-1 text-decoration-none",
                                                                            onclick:
                                                                                this.method(
                                                                                    "updateExtraQty",
                                                                                    [
                                                                                        extra.id,
                                                                                        -1,
                                                                                    ],
                                                                                ),
                                                                        },
                                                                        h.i({
                                                                            class: "bi bi-dash fs-5",
                                                                        }),
                                                                    ),
                                                                    h.span(
                                                                        {
                                                                            class: "fw-bold px-2 small",
                                                                            style: "min-width: 25px; text-align: center;",
                                                                        },
                                                                        qty,
                                                                    ),
                                                                    h.button(
                                                                        {
                                                                            class: "btn btn-link text-dark p-1 text-decoration-none",
                                                                            onclick:
                                                                                this.method(
                                                                                    "updateExtraQty",
                                                                                    [
                                                                                        extra.id,
                                                                                        1,
                                                                                        extra,
                                                                                    ],
                                                                                ),
                                                                        },
                                                                        h.i({
                                                                            class: "fas fa-plus fs-5",
                                                                        }),
                                                                    ),
                                                                ),
                                                            () =>
                                                                h.button(
                                                                    {
                                                                        class: "btn btn-outline-primary rounded-circle p-0 d-flex align-items-center justify-content-center",
                                                                        style: "width: 32px; height: 32px;",
                                                                        onclick:
                                                                            this.method(
                                                                                "updateExtraQty",
                                                                                [
                                                                                    extra.id,
                                                                                    1,
                                                                                    extra,
                                                                                ],
                                                                            ),
                                                                    },
                                                                    h.i({
                                                                        class: "bi bi-plus-lg",
                                                                    }),
                                                                ),
                                                        );
                                                    },
                                                ),
                                            ),
                                        ),
                                    ),
                                ),

                                // Global Quantity (Final Field)
                                h.div(
                                    { class: "mt-auto pt-4 mb-5" },
                                    h.div(
                                        {
                                            class: "d-flex align-items-center justify-content-center",
                                        },

                                        h.div(
                                            {
                                                class: "d-flex align-items-center border rounded-pill p-3 bg-light",
                                            },
                                            h.button(
                                                {
                                                    class: "btn btn-link text-dark p-2 text-decoration-none",
                                                    listeners: {
                                                        click: () => {
                                                            this.globalQuantity.value =
                                                                Math.max(
                                                                    1,
                                                                    this
                                                                        .globalQuantity
                                                                        .value -
                                                                        1,
                                                                );
                                                            this.updateConfigMap(
                                                                product.id,
                                                            );
                                                        },
                                                    },
                                                },
                                                h.i({ class: "bi bi-dash-lg" }),
                                            ),
                                            h.span(
                                                {
                                                    class: "fw-bold px-4 fs-5",
                                                    style: "min-width: 60px; text-align: center;",
                                                },
                                                v(this.globalQuantity),
                                            ),
                                            h.button(
                                                {
                                                    class: "btn btn-link text-dark p-2 text-decoration-none",
                                                    listeners: {
                                                        click: () => {
                                                            this.globalQuantity
                                                                .value++;
                                                            this.updateConfigMap(
                                                                product.id,
                                                            );
                                                        },
                                                    },
                                                },
                                                h.i({ class: "bi bi-plus-lg" }),
                                            ),
                                        ),
                                    ),
                                ),
                            ),
                        ),
                    );
                }),

                // Related Products Section
                v(this.fetchingRelated, (fetchRelState) => {
                    if (fetchRelState.value) {
                        return h.div(
                            {
                                class: "related-products-section mt-5 mb-5 px-4 text-center",
                            },
                            h.SmallSpinner(),
                        );
                    }

                    return v(this.relatedProducts, (relProductsState) => {
                        const rels = relProductsState.value || [];
                        if (rels.length === 0) {
                            return h.div({ class: "d-none" });
                        }

                        return h.div(
                            {
                                class: "related-products-section mt-5 mb-5 px-4",
                            },
                            h.div(
                                {
                                    class: "d-flex align-items-center justify-content-between mb-4",
                                },
                                h.h4(
                                    { class: "fw-bold mb-0" },
                                    "Many people also bought",
                                ),
                            ),
                            h.div(
                                {
                                    class: "d-flex flex-nowrap overflow-x-auto pb-3 gap-3 desktop-scrollbar",
                                    style: "scrollbar-width: none;",
                                },
                                each(rels, (rp) =>
                                    h.SearchResultProductView(rp, {
                                        class: "flex-shrink-0",
                                        style: "width: 180px;",
                                        onclick: this.method(
                                            "showRelatedProduct",
                                            rp,
                                        ),
                                    }),
                                ),
                            ),
                        );
                    });
                }),

                v(this.fetchingProduct, (fetchState) => {
                    if (fetchState.value) {
                        return h.SmallSpinner();
                    }

                    // Product-specific time-of-day window (available_from/
                    // available_until) - separate from isShopClosed below,
                    // which is about the SHOP's own hours. Computed once
                    // here (not reactively) since it doesn't depend on the
                    // user's current selections, just the clock.
                    const timeAvailability =
                        getProductAvailabilityWindow(product);

                    return h.div(
                        {
                            class: "d-grid p-3 position-absolute bottom-0 end-0 w-100",
                        },
                        timeAvailability.available
                            ? null
                            : h.div(
                                  {
                                      class: "alert alert-warning py-2 px-3 mb-2 small d-flex align-items-center gap-2 rounded-3",
                                  },
                                  h.i({ class: "bi bi-clock-fill" }),
                                  h.span(timeAvailability.message),
                              ),
                        v(
                            this.selectedFeatures,
                            (selFeatsState) => {
                                const selFeats = selFeatsState.value || {};
                                let hasAllRequired = true;
                                if (product.features) {
                                    for (
                                        let i = 0;
                                        i < product.features.length;
                                        i++
                                    ) {
                                        const f = product.features[i];
                                        if (f.is_required) {
                                            const selection = selFeats[f.id];
                                            if (
                                                !this.isFeatureSelectionValid(
                                                    f,
                                                    selection,
                                                )
                                            ) {
                                                hasAllRequired = false;
                                                break;
                                            }
                                        }
                                    }
                                }

                                const isOutOfStock =
                                    product.has_stock_information &&
                                    product.quantity <= 0;
                                // See Product::is_available on the backend
                                // (App\Services\AvailabilityService) - false
                                // only once the business's own operating
                                // hours (or online status) say it's closed
                                // right now.
                                const isShopClosed =
                                    product?.is_available === false;
                                return h.button(
                                    {
                                        class: "btn btn-primary btn-lg rounded-pill fw-bold shadow-sm border-0 py-3 w-100",
                                        ...either(
                                            !hasAllRequired ||
                                                isOutOfStock ||
                                                isShopClosed ||
                                                !timeAvailability.available,
                                            {
                                                disabled: "disabled",
                                            },
                                        ),
                                        listeners: {
                                            click: () => {
                                                // Belt-and-braces alongside the disabled
                                                // attribute above - a disabled button can
                                                // still receive a click in some browsers/
                                                // input methods, and this is the one place
                                                // an order actually gets placed from here.
                                                if (!timeAvailability.available) {
                                                    inform(
                                                        timeAvailability.message ||
                                                            "This product isn't available right now.",
                                                        STRINGS.ERROR,
                                                    );
                                                    return;
                                                }
                                                const qty =
                                                    this.globalQuantity.value;

                                                // Same resolution as the button label and the
                                                // header discount badge - prefer the deal-discounted
                                                // price when one applies, so the cart's optimistic
                                                // display (Cart.js's finalBasePrice) matches what the
                                                // backend actually charges (CartItem::getPriceAttribute()).
                                                const pricing =
                                                    this.computeDisplayPricing(
                                                        product,
                                                    );
                                                const finalBasePrice =
                                                    pricing.hasDiscount
                                                        ? pricing.discountedPrice
                                                        : pricing.displayPrice;
                                                product.buyable_type =
                                                    "App\\Models\\Product";

                                                const extrasMap = {};
                                                const productExtras =
                                                    product.extras || [];
                                                for (let extraId in this
                                                    .extraQuantities.value) {
                                                    let extraProduct =
                                                        productExtras.find(
                                                            (x) =>
                                                                x.id == extraId,
                                                        );
                                                    if (extraProduct) {
                                                        extrasMap[extraId] =
                                                            extraProduct.name;
                                                    }
                                                }

                                                const cartItem = {
                                                    product: product,
                                                    finalBasePrice:
                                                        finalBasePrice,
                                                    selectedFeatures:
                                                        this.selectedFeatures
                                                            .value,
                                                    extraQuantities:
                                                        this.extraQuantities
                                                            .value,
                                                    selectedExtraFeatures:
                                                        this
                                                            .selectedExtraFeatures
                                                            .value,
                                                    extras: extrasMap,
                                                    quantity: qty,
                                                };

                                                if (this.cartItem.value) {
                                                    const rowId =
                                                        this.cartItem.value
                                                            .key ||
                                                        `row-${product.id}-${this.cartItem.value.cart_item_id || "default"}`;
                                                    broker.broadcast(
                                                        $e.cart.needs
                                                            .itemUpdate,
                                                        payload({
                                                            quantity: qty,
                                                            rowId: rowId,
                                                            cartItem: cartItem,
                                                        }),
                                                    );
                                                } else {
                                                    broker.broadcast(
                                                        $e.cart.itemSelected,
                                                        payload({
                                                            item: product,
                                                            quantity: qty,
                                                            cartItem: cartItem,
                                                        }),
                                                    );
                                                }

                                                this.closeProductView();
                                            },
                                        },
                                    },
                                    v(this.globalQuantity, (qtyState) => {
                                        const qty = qtyState.value;
                                        return v(
                                            this.extraQuantities,
                                            (extsState) => {
                                                const exts =
                                                    extsState.value || {};
                                                return v(
                                                    this.selectedFeatures,
                                                    (selFeatsStateNested) => {
                                                        const selFeatsNested =
                                                            selFeatsStateNested.value ||
                                                            {};
                                                        return v(
                                                            this
                                                                .selectedExtraFeatures,
                                                            (
                                                                selExtraFeatsState,
                                                            ) => {
                                                                const selExtraFeats =
                                                                    selExtraFeatsState.value ||
                                                                    {};

                                                                return this.computeCartButtonLabel(
                                                                    product,
                                                                    qty,
                                                                    exts,
                                                                    selFeatsNested,
                                                                    selExtraFeats,
                                                                    userCurrency,
                                                                );
                                                            },
                                                        );
                                                    },
                                                );
                                            },
                                        );
                                    }),
                                );
                            },
                            { $class: "d-block", class: "d-block" },
                        ),
                    );
                }),
            );
        });
    }

    async showExtraFeaturesModal(extra) {
        // Fetch detailed extra product if it has features but we don't have them yet
        let details = extra;
        if (!extra.features) {
            let res = await api.get(
                `/products/${extra.buyable_id || extra.id}`,
                {},
                { silent: true },
            );
            if (res && res.data && res.data.product) {
                details = res.data.product;
            }
        }

        if (!details.features || details.features.length === 0) {
            // No features, directly update quantity
            const current = this.extraQuantities.value[extra.id] || 0;
            const updated = { ...this.extraQuantities.value };
            updated[extra.id] = current + 1;
            this.extraQuantities.value = updated;
            return;
        }

        // Show plainModal for features selection
        if (this.extraFeaturesHolder) {
            cleanDispose(this.extraFeaturesHolder);
        }

        const userCurrency = dc.userCurrency;

        const modalContent = h.ExtraFeaturesModal(
            h.div(
                { class: "extra-features-modal-body" },
                h.h4(
                    { class: "fw-bold text-dark mb-3" },
                    `Customize ${extra.name} (${monetary(details.final_price, userCurrency)})`,
                ),
                h.div(
                    { class: "features-list mb-4" },
                    each(details.features, (feature) =>
                        h.div(
                            { class: "mb-3 pb-3 border-bottom border-light" },
                            h.div(
                                {
                                    class: "d-flex justify-content-between align-items-center mb-1",
                                },
                                h.span(
                                    { class: "fw-bold text-dark" },
                                    feature.name,
                                ),
                                either(feature.is_required, () =>
                                    h.span(
                                        {
                                            class: "badge bg-danger-subtle text-danger small rounded-pill px-2.5",
                                        },
                                        "Required",
                                    ),
                                ),
                            ),
                            this.getChoiceTypeLabel(feature.choice_type),
                            h.div(
                                { class: "options-container mt-2" },
                                this.renderFeatureInput(
                                    feature,
                                    this.selectedExtraFeatures,
                                    userCurrency,
                                    extra.id,
                                ),
                            ),
                        ),
                    ),
                ),
                h.div(
                    { class: "d-grid gap-2" },
                    v(
                        this.selectedExtraFeatures,
                        (extraSelState) => {
                            const extraSel = extraSelState.value || {};
                            const extraFeats = extraSel[extra.id] || {};

                            let hasAllRequired = true;
                            if (details.features) {
                                for (
                                    let i = 0;
                                    i < details.features.length;
                                    i++
                                ) {
                                    const f = details.features[i];
                                    if (f.is_required) {
                                        const selection = extraFeats[f.id];
                                        if (
                                            !this.isFeatureSelectionValid(
                                                f,
                                                selection,
                                            )
                                        ) {
                                            hasAllRequired = false;
                                            break;
                                        }
                                    }
                                }
                            }

                            return h.button(
                                {
                                    class: "btn btn-dark rounded-3 py-3 fw-bold w-100",
                                    ...either(!hasAllRequired, {
                                        disabled: "disabled",
                                    }),
                                    listeners: {
                                        click: () => {
                                            const current =
                                                this.extraQuantities.value[
                                                    extra.id
                                                ] || 0;
                                            updateStateValue(
                                                this.extraQuantities,
                                                (updated) => {
                                                    updated[extra.id] =
                                                        current + 1;
                                                    return updated;
                                                },
                                            );
                                            this.updateConfigMap(
                                                this.currentProductId,
                                            );
                                            this.extraFeaturesHolder.hide();
                                        },
                                    },
                                },
                                "Confirm & Add Extra",
                            );
                        },
                        { $class: "d-block", class: "d-block" },
                    ),
                ),
            ),
        );

        this.extraFeaturesHolder = tool.plainModal(modalContent, {});
        this.extraFeaturesHolder.show();
    }

    updateExtraQty(id, delta, extra) {
        const current = this.extraQuantities.value[id] || 0;
        if (delta === 1 && extra && current === 0) {
            this.showExtraFeaturesModal(extra);
            return;
        }

        const newVal = Math.max(0, current + delta);

        updateStateValue(this.extraQuantities, (updated) => {
            if (newVal === 0) {
                delete updated[id];
                // Also clean up features if deleted
                updateStateValue(this.selectedExtraFeatures, (extraSel) => {
                    delete extraSel[id];
                    return extraSel;
                });
            } else {
                updated[id] = newVal;
            }
            return updated;
        });
        this.updateConfigMap(this.currentProductId);
    }

    async showRelatedProduct(product) {
        broker.send($e.product.needs.display, payload({ product }));
    }

    async showProduct(ed, event) {
        if (this.holder) {
            cleanDispose(this.holder);
        }

        let { message } = eParse(ed);
        let product = message.product;
        let cItem = message.cart_item || null;

        this.currentProductId = product.id;
        this.cartItem.value = cItem;

        if (cItem) {
            product = cItem.product || cItem.model || product;
            this.globalQuantity.value = cItem.qty || cItem.quantity || 1;

            // Map selected features and extras
            this.selectedFeatures.value =
                cItem.selectedFeatures || cItem.options?.selectedFeatures || {};
            this.extraQuantities.value =
                cItem.extraQuantities || cItem.options?.extraQuantities || {};
            this.selectedExtraFeatures.value =
                cItem.selectedExtraFeatures ||
                cItem.options?.selectedExtraFeatures ||
                {};
        } else {
            // Check if product is in cart
            let isInCart = uc.cartMap.value && uc.cartMap.value[product.id];
            let cachedCfg =
                dc.productConfigurationMap.value &&
                dc.productConfigurationMap.value[product.id];

            if (!isInCart && cachedCfg) {
                // Populate selections from global cache map
                this.globalQuantity.value = cachedCfg.quantity || 1;
                this.selectedFeatures.value = cachedCfg.selectedFeatures
                    ? JSON.parse(JSON.stringify(cachedCfg.selectedFeatures))
                    : {};
                this.extraQuantities.value = cachedCfg.extraQuantities
                    ? JSON.parse(JSON.stringify(cachedCfg.extraQuantities))
                    : {};
                this.selectedExtraFeatures.value =
                    cachedCfg.selectedExtraFeatures
                        ? JSON.parse(
                              JSON.stringify(cachedCfg.selectedExtraFeatures),
                          )
                        : {};
            } else {
                // Reset to clean defaults
                this.globalQuantity.value = 1;
                this.selectedFeatures.value = {};
                this.extraQuantities.value = {};
                this.selectedExtraFeatures.value = {};
            }
        }

        let pState = state(product);

        this.fetchingProduct.value = true;

        this.fetchProduct(product.id, pState);

        if (isMobile()) {
            this.holder = tool.offcanvas(
                h.ViewProductCanvas(this.renderForm(pState, "offcanvas"), {
                    class: "p-0 rounded-top-5",
                }),
            );
        } else {
            this.holder = tool.plainModal(
                h.ViewProductModal(this.renderForm(pState, "modal")),
                {},
            );
        }

        this.holder.show();
    }

    closeProductView() {
        this.holder.hide();
    }

    updateConfigMap(productId) {
        let isInCart = uc.cartMap.value && uc.cartMap.value[productId];

        if (!isInCart) {
            updateStateValue(dc.productConfigurationMap, (map) => {
                map[productId] = {
                    quantity: this.globalQuantity.value,
                    selectedFeatures: this.selectedFeatures.value,
                    extraQuantities: this.extraQuantities.value,
                    selectedExtraFeatures: this.selectedExtraFeatures.value,
                };
                return map;
            });
        }
    }

    getChoiceTypeLabel(choiceType) {
        let labelText = "";
        switch (choiceType) {
            case "single_choice":
                labelText = "Choose one option";
                break;
            case "multiple_choice":
                labelText = "Choose one or more options";
                break;
            case "text":
                labelText = "Enter text";
                break;
            case "number":
                labelText = "Enter number";
                break;
            case "range":
                labelText = "Select level";
                break;
            case "file":
                labelText = "Upload a file";
                break;
            default:
                labelText = "Toggle preference";
                break;
        }
        return h.p(
            {
                class: "text-muted small mb-3",
            },
            labelText,
        );
    }

    // Live client-side estimate for a Number Input feature that affects price.
    // price = (entered value / price_interval) * price_per_interval, rounded to 2dp.
    // Returns 0 when the feature doesn't affect price, or the entry isn't a valid
    // positive number, or the merchant hasn't configured a rate.
    computeNumberFeaturePrice(feature, rawValue) {
        if (!feature.has_different_prices) return 0;

        const value = parseFloat(rawValue);
        const interval = parseFloat(feature.price_interval);
        const pricePerInterval = parseFloat(feature.price_per_interval);

        if (!(value > 0) || !(interval > 0) || isNaN(pricePerInterval)) {
            return 0;
        }

        return Math.ceil(((value / interval) * pricePerInterval) * 100) / 100;
    }

    // Mirrors ProductService::calculateFinalPrice's commission bracket math on the
    // backend, using the SAME source of truth: the commission rate/payer per bracket
    // come from window.systemConfigs (populated from ConfigController::getConfig's
    // systemConfigs, backed by SettingService/SystemSetting) rather than being
    // hardcoded here - if an admin changes a rate or payer, this estimate picks it up
    // on the next config load, same as the backend does on its next request.
    //
    // Any of the four brackets can independently be configured as payer 'customer'
    // (customer bears the full rate), 'business' (business absorbs it, no markup to
    // the customer), or 'split' (negotiated between business and customer) - it's
    // not just the top bracket. For 'split', the business's actual commission_rate /
    // customer_commission_rate stay internal to the backend; product.commission_
    // customer_share is a pre-derived ratio (customer's share of the split, 0..1)
    // that reveals only the proportion, never the absolute rates.
    estimateFinalPrice(rawTotal, product) {
        if (!(rawTotal > 0)) return 0;

        const sys = window.systemConfigs || {};
        let rate;
        let payer;

        if (rawTotal <= 50) {
            rate = sys.commissionRateUpTo50 ?? 5;
            payer = sys.commissionPayerUpTo50 ?? "customer";
        } else if (rawTotal <= 100) {
            rate = sys.commissionRateUpTo100 ?? 10;
            payer = sys.commissionPayerUpTo100 ?? "customer";
        } else if (rawTotal <= 150) {
            rate = sys.commissionRateUpTo150 ?? 12;
            payer = sys.commissionPayerUpTo150 ?? "split";
        } else {
            rate = sys.commissionRateAbove150 ?? 13;
            payer = sys.commissionPayerAbove150 ?? "split";
        }

        let customerRate;
        if (!product?.company) {
            // No owning company: the backend always charges the customer the full
            // published rate in this case (calculateFinalPrice's empty($company)
            // branch), regardless of the payer setting.
            customerRate = rate;
        } else if (payer === "business") {
            customerRate = 0;
        } else if (payer === "split") {
            const share = parseFloat(product?.commission_customer_share);
            customerRate = rate * (isNaN(share) ? 0 : share);
        } else {
            customerRate = rate;
        }

        const customerMarkup = Math.max(
            Math.floor((rawTotal * customerRate) / 100),
            1,
        );
        return Math.floor(rawTotal + customerMarkup);
    }

    // A Number Input feature's commission bracket is based on the full line total
    // (rawUnitPrice * quantity), not a single unit - so we compute the tiered total
    // first, then divide back to an "effective per-unit" price. Multiplying that
    // back out by the same quantity (as the rest of this view already does for the
    // running total / Add-to-Cart button) reproduces the correctly-bracketed total.
    estimateNumberFeatureUnitPrice(rawUnitPrice, qty, product) {
        const quantity = Math.max(1, parseInt(qty) || 1);
        const rawTotal = rawUnitPrice * quantity;
        const finalTotal = this.estimateFinalPrice(rawTotal, product);
        return finalTotal / quantity;
    }

    // The single currently-active deal on this product (business-owned or global/
    // Carata-owned), mirroring Product::currentDeal() on the backend: when more than
    // one active deal is attached, the most recently updated one wins. Returns null
    // when nothing is currently discounting this product.
    getActiveDeal(product) {
        const now = new Date();
        const active = (product?.deals || []).filter((deal) => {
            if (!deal.active) return false;
            if (deal.starts_at && new Date(deal.starts_at) > now) return false;
            if (deal.ends_at && new Date(deal.ends_at) < now) return false;
            return true;
        });
        if (active.length === 0) return null;
        active.sort(
            (a, b) => new Date(b.updated_at) - new Date(a.updated_at),
        );
        return active[0];
    }

    // Mirrors Deal::discountAmountFor on the backend.
    computeDealDiscountAmount(deal, rawPrice) {
        if (!deal || !(rawPrice > 0)) return null;
        if (deal.type === "percentage") {
            return rawPrice * (parseFloat(deal.value) / 100);
        }
        const value = parseFloat(deal.value);
        if (!(value < rawPrice)) return null;
        return value;
    }

    // Mirrors ProductService::totalCommission - Carata's own commission (in currency,
    // not a rate) on a sale at this price, independent of which company owns the
    // product. This is the ceiling a global/Carata-funded deal can discount a price by
    // without touching the business's payout at all - see estimateDiscountedFinalPrice.
    estimateTotalCommission(rawPrice) {
        const sys = window.systemConfigs || {};
        let rate;
        if (rawPrice <= 50) rate = sys.commissionRateUpTo50 ?? 5;
        else if (rawPrice <= 100) rate = sys.commissionRateUpTo100 ?? 10;
        else if (rawPrice <= 150) rate = sys.commissionRateUpTo150 ?? 12;
        else rate = sys.commissionRateAbove150 ?? 13;
        return Math.floor((rawPrice * rate) / 100);
    }

    // Mirrors Product::discountedPriceFor on the backend - the discounted,
    // commission-bracketed price for an arbitrary raw (pre-commission) price under
    // this product's currently active deal, or null if no deal applies / it doesn't
    // reduce this particular price. Used to keep the discount badge, and any live
    // feature/number-input price estimate, in sync with whatever the customer has
    // selected right now, the same way estimateFinalPrice keeps the non-discounted
    // estimate in sync - this is purely a display estimate; the backend always
    // recomputes and is the source of truth for anything actually charged.
    estimateDiscountedFinalPrice(rawPrice, product, deal) {
        if (!deal || !(rawPrice > 0)) return null;

        const discountAmount = this.computeDealDiscountAmount(deal, rawPrice);
        if (discountAmount === null) return null;

        if (!deal.company_id) {
            // Global deal: the discount comes off the final (marked-up) price, capped
            // at Carata's own commission so the business's payout is never touched.
            const normalFinal = this.estimateFinalPrice(rawPrice, product);
            const ceiling = this.estimateTotalCommission(rawPrice);
            const applied = Math.min(discountAmount, ceiling);
            return Math.max(normalFinal - applied, 0);
        }

        // Business-owned deal: the discount comes off the raw price before
        // commission is recalculated on the reduced base.
        const discountedBase = Math.max(rawPrice - discountAmount, 0);
        return this.estimateFinalPrice(discountedBase, product);
    }

    // Discount-aware sibling of estimateNumberFeatureUnitPrice - same quantity
    // folding, but the tiered total is run through the active deal first.
    estimateDiscountedNumberFeatureUnitPrice(rawUnitPrice, qty, product, deal) {
        if (!deal) return null;
        const quantity = Math.max(1, parseInt(qty) || 1);
        const rawTotal = rawUnitPrice * quantity;
        const discountedTotal = this.estimateDiscountedFinalPrice(
            rawTotal,
            product,
            deal,
        );
        return discountedTotal === null ? null : discountedTotal / quantity;
    }

    // Resolves what price to actually SHOW right now for the product header -
    // the base price, or whatever price-affecting Feature/Number-Input the
    // customer currently has selected (mirrors the same resolution the
    // Add-to-Cart button/running total already does) - together with the
    // deal-discounted counterpart of THAT exact price, so the discount badge
    // never goes stale relative to what's about to be added to the cart.
    computeDisplayPricing(product) {
        const p = product;
        const baseDisplayPrice = parseFloat(
            p.final_price || p.selling_price || p.price || 0,
        );

        const selFeatsNested = this.selectedFeatures.value || {};
        const qty = this.globalQuantity.value;

        let affectingFeaturePrice = null; // final (commissioned), per-unit
        let affectingRawPrice = null; // pre-commission, per-unit (Number features only)
        let affectingDiscountedFinal = null; // backend-resolved discounted price (choice features only)
        let isNumberFeature = false;

        for (const featId in selFeatsNested) {
            if (
                !Object.prototype.hasOwnProperty.call(selFeatsNested, featId)
            ) {
                continue;
            }
            const values = selFeatsNested[featId] || [];
            for (let i = 0; i < values.length; i++) {
                const vObj = values[i];
                if (
                    vObj &&
                    vObj.affect_price &&
                    parseFloat(vObj.final_price) !== 0
                ) {
                    isNumberFeature = !!vObj.is_number_feature;
                    if (isNumberFeature) {
                        // vObj.final_price is the RAW per-unit price for Number
                        // features (see the input handler above) - commission and
                        // discount are both applied on the quantity-inclusive total.
                        affectingRawPrice = parseFloat(vObj.final_price);
                        affectingFeaturePrice = this.estimateNumberFeatureUnitPrice(
                            affectingRawPrice,
                            qty,
                            p,
                        );
                        affectingDiscountedFinal = null;
                    } else {
                        affectingFeaturePrice = parseFloat(vObj.final_price);
                        affectingDiscountedFinal =
                            vObj.discounted_final_price != null
                                ? parseFloat(vObj.discounted_final_price)
                                : null;
                    }
                }
            }
        }

        const packagePrice = parseFloat(p.package_price || 0);
        const displayPrice =
            affectingFeaturePrice !== null
                ? affectingFeaturePrice + packagePrice
                : baseDisplayPrice;

        const deal = this.getActiveDeal(p);

        let discountedPrice = null;
        if (affectingFeaturePrice !== null) {
            if (isNumberFeature) {
                const discountedUnit =
                    this.estimateDiscountedNumberFeatureUnitPrice(
                        affectingRawPrice,
                        qty,
                        p,
                        deal,
                    );
                discountedPrice =
                    discountedUnit !== null
                        ? discountedUnit + packagePrice
                        : null;
            } else if (affectingDiscountedFinal !== null) {
                discountedPrice = affectingDiscountedFinal + packagePrice;
            }
        } else {
            discountedPrice =
                p.discounted_price != null
                    ? parseFloat(p.discounted_price)
                    : null;
        }

        const hasDiscount =
            discountedPrice != null && discountedPrice < displayPrice;
        const discountPercent =
            hasDiscount && displayPrice > 0
                ? Math.round((1 - discountedPrice / displayPrice) * 100)
                : 0;

        return {
            displayPrice,
            hasDiscount,
            discountedPrice,
            discountPercent,
            activeDeal: hasDiscount ? deal : null,
        };
    }

    // Builds the Add/Update-to-cart button's label - the same unit-price
    // resolution as the discount badge (computeDisplayPricing) and the
    // Add-to-Cart click handler, so the button always promises exactly what
    // will actually be charged, deal discount included (the backend now
    // charges the discounted price whenever one applies - see
    // CartItem::getPriceAttribute() on the API).
    computeCartButtonLabel(product, qty, exts, selFeatsNested, selExtraFeats, userCurrency) {
        if (product?.is_available === false) {
            return "Shop Closed";
        }

        if (!getProductAvailabilityWindow(product).available) {
            return "Not Available Yet";
        }

        if (product.has_stock_information && product.quantity <= 0) {
            return "Out of Stock";
        }

        let extrasTotal = 0;
        (product.extras || []).forEach((e) => {
            const extraQty = exts[e.id];
            if (!extraQty) return;

            const cachedExtra = e.buyable || {};
            const discountedExtraPrice =
                e.discounted_price != null ? parseFloat(e.discounted_price) : null;
            let baseExtraPrice =
                discountedExtraPrice !== null
                    ? discountedExtraPrice
                    : parseFloat(e.final_price || 0);

            // Search for any selection that has affect_price = true on the extra -
            // prefer its own discounted price when one applies, same as the base item.
            const feats = selExtraFeats[e.id] || {};
            for (const featId in feats) {
                if (!Object.prototype.hasOwnProperty.call(feats, featId)) continue;
                const values = feats[featId] || [];
                for (let i = 0; i < values.length; i++) {
                    const vObj = values[i];
                    if (
                        vObj &&
                        vObj.affect_price &&
                        parseFloat(vObj.final_price) !== 0
                    ) {
                        const effective =
                            vObj.discounted_final_price != null
                                ? parseFloat(vObj.discounted_final_price)
                                : parseFloat(vObj.final_price);
                        baseExtraPrice =
                            effective + parseFloat(cachedExtra.package_price || 0);
                        break;
                    }
                }
            }

            extrasTotal += baseExtraPrice * extraQty;
        });

        // this.selectedFeatures/globalQuantity are the exact live state
        // computeDisplayPricing reads from, so this reflects the same
        // selection the button is being built for right now.
        const pricing = this.computeDisplayPricing(product);
        const unitPrice = pricing.hasDiscount
            ? pricing.discountedPrice
            : pricing.displayPrice;

        const total = (unitPrice + extrasTotal) * qty;
        const labelAction = this.cartItem.value ? "Update" : "Add";
        return `${labelAction} ${qty} for ${monetary(total, userCurrency)}`;
    }

    // A required feature's current selection is valid when it has a non-empty value,
    // and - for a Number Input that affects price - when that value is a positive
    // number (0/blank/negative would compute to a meaningless or zero price).
    isFeatureSelectionValid(feature, selection) {
        if (!selection || selection.length === 0) return false;

        const first = selection[0];
        if (!first || first.value === "" || first.value === undefined) {
            return false;
        }

        if (
            feature.choice_type === "number" &&
            feature.has_different_prices &&
            !(parseFloat(first.value) > 0)
        ) {
            return false;
        }

        return true;
    }

    renderFeatureInput(feature, targetState, userCurrency, extraId = null) {
        const type = feature.choice_type;

        switch (type) {
            case "file": {
                const sel = targetState.value || {};
                const existing =
                    extraId !== null
                        ? sel[extraId]?.[feature.id]?.[0]
                        : sel[feature.id]?.[0];

                // idle | uploading | done | error - purely local to this
                // render pass. Re-rendered from scratch (via the outer
                // v(this.selectedFeatures, ...)/v(this.selectedExtraFeatures, ...))
                // once the upload succeeds and targetState changes, so it
                // only has to track the in-flight request itself.
                const uploadStatus = state(existing ? "done" : "idle");
                const fileLabel = state(
                    existing?.file_name || (existing ? "File uploaded" : ""),
                );

                const inputId = `feature-file-${feature.id}${
                    extraId !== null ? `-extra-${extraId}` : ""
                }`;
                const buttonLabel = feature.value_label || "Add File";

                const handleFileChange = async (e) => {
                    const file = e.target.files && e.target.files[0];
                    if (!file) return;

                    const allowedTypes = [
                        "image/jpeg",
                        "image/png",
                        "image/webp",
                        "application/pdf",
                    ];
                    if (file.type && !allowedTypes.includes(file.type)) {
                        inform(
                            "Please choose a JPG, PNG, WEBP or PDF file",
                            STRINGS.WARNING,
                        );
                        e.target.value = "";
                        return;
                    }
                    if (file.size > 10 * 1024 * 1024) {
                        inform(
                            "That file is too large - max 10MB",
                            STRINGS.WARNING,
                        );
                        e.target.value = "";
                        return;
                    }

                    uploadStatus.value = "uploading";

                    const formData = new FormData();
                    formData.append("file", file);

                    try {
                        const res = await api.post(
                            routes.featureFile(feature.id),
                            formData,
                            {
                                fetch_using: "browser",
                                "remove-content-type": true,
                            },
                        );

                        // The backend wraps every response as
                        // {status, message, data} (see Util::respond()) -
                        // the uploaded path is res.data.value, not res.value.
                        const uploadedValue = res?.data?.value;

                        if (!res || !uploadedValue) {
                            throw new Error("Upload did not return a value");
                        }

                        uploadStatus.value = "done";
                        fileLabel.value = file.name;

                        updateStateValue(targetState, (s) => {
                            const entry = {
                                feature_name: feature.name ?? null,
                                value: uploadedValue,
                                final_price: 0,
                                affect_price: false,
                                is_file_feature: true,
                                // Display-only - not relied on by the
                                // backend (it re-derives everything from
                                // the stored path), just so this button
                                // can show what was picked after a
                                // reopen/re-render.
                                file_name: file.name,
                            };
                            if (extraId !== null) {
                                const extraFeats = s[extraId] || {};
                                extraFeats[feature.id] = [entry];
                                s[extraId] = extraFeats;
                            } else {
                                s[feature.id] = [entry];
                            }
                            return s;
                        });
                        this.updateConfigMap(this.currentProductId);
                    } catch (err) {
                        uploadStatus.value = existing ? "done" : "error";
                        inform(
                            "Couldn't upload that file - please try again",
                            STRINGS.ERROR,
                        );
                    }
                };

                return h.div(
                    { class: "d-flex flex-column gap-2" },
                    h.input({
                        type: "file",
                        id: inputId,
                        accept: ".jpg,.jpeg,.png,.webp,.pdf",
                        class: "d-none",
                        listeners: { change: handleFileChange },
                    }),
                    v(uploadStatus, (s) => {
                        if (s.value === "uploading") {
                            return h.div(
                                {
                                    class: "d-flex align-items-center gap-2 text-muted small",
                                },
                                h.SmallSpinner(),
                                "Uploading...",
                            );
                        }

                        return h.label(
                            {
                                for: inputId,
                                class:
                                    s.value === "done"
                                        ? "btn btn-outline-success rounded-3 py-2 px-3 fw-bold d-flex align-items-center gap-2 mb-0"
                                        : "btn border text-primary rounded-3 py-2 px-3 fw-bold d-flex align-items-center gap-2 mb-0",
                            },
                            h.i({
                                class:
                                    s.value === "done"
                                        ? "bi bi-check-circle"
                                        : "bi bi-upload",
                            }),
                            s.value === "done"
                                ? v(
                                      fileLabel,
                                      (n) => n.value || "File added - tap to replace",
                                  )
                                : buttonLabel,
                        );
                    }),
                    h.small(
                        { class: "d-flex text-success gap-1" },
                        h.i({ class: "bi bi-lock-fill" }),
                        "Visible only to business. Encrypted at rest.",
                    ),
                );
            }

            case "text":
            case "number": {
                // Determine initial value from productConfigurationMap (if not in cart) or targetState directly
                const prodId = feature.product_id || this.currentProductId;
                const isInCart = uc.cartMap.value && uc.cartMap.value[prodId];
                const cachedCfg =
                    dc.productConfigurationMap.value &&
                    dc.productConfigurationMap.value[prodId];

                let initialVal = "";
                if (!isInCart && cachedCfg && cachedCfg.selectedFeatures) {
                    const featSel = cachedCfg.selectedFeatures[feature.id];
                    if (featSel && featSel[0]) {
                        initialVal = featSel[0].value || "";
                    }
                } else {
                    const sel = targetState.value || {};
                    const featSel =
                        extraId !== null
                            ? sel[extraId]?.[feature.id]
                            : sel[feature.id];
                    if (featSel && featSel[0]) {
                        initialVal = featSel[0].value || "";
                    }
                }

                return h.input({
                    class: "form-control bg-light p-3 rounded-3 border",
                    type: type === "number" ? "number" : "text",
                    // Without this, the browser's built-in validation flags decimal
                    // entries (e.g. 0.5) as invalid on a plain <input type="number">
                    // (default step is 1, whole numbers only). Harmless on type="text".
                    step: "any",
                    value: initialVal,
                    placeholder:
                        feature.value_label || `Enter ${feature.name}...`,
                    listeners: {
                        input: (e) => {
                            const rawValue = e.target.value;
                            // Number Input features can affect price: the merchant sets a
                            // rate ("for every 0.5, the price is 10") and we compute the
                            // RAW per-unit price from whatever the customer types, e.g.
                            // entering 3 costs (3 / 0.5) * 10 = 60. The commission markup
                            // is NOT applied here - it depends on quantity (the bracket is
                            // based on the full line total, not one unit), so that step
                            // happens later wherever quantity is known (see
                            // estimateNumberFeatureUnitPrice). This is a live client-side
                            // estimate for display only - the backend always recomputes
                            // and charges the authoritative price from the same feature
                            // rate, never trusting this value.
                            const affectsPrice =
                                type === "number" &&
                                !!feature.has_different_prices;
                            const computedPrice = affectsPrice
                                ? this.computeNumberFeaturePrice(
                                      feature,
                                      rawValue,
                                  )
                                : 0;

                            updateStateValue(targetState, (sel) => {
                                const entry = {
                                    feature_name: feature.name ?? null,
                                    value: rawValue,
                                    final_price: computedPrice,
                                    affect_price: affectsPrice,
                                    is_number_feature: type === "number",
                                };
                                if (extraId !== null) {
                                    const extraFeats = sel[extraId] || {};
                                    extraFeats[feature.id] = [entry];
                                    sel[extraId] = extraFeats;
                                } else {
                                    sel[feature.id] = [entry];
                                }
                                return sel;
                            });
                            this.updateConfigMap(this.currentProductId);
                        },
                    },
                });
            }

            default:
                // Single Choice or Multiple Choice
                return h.div(
                    {
                        class: "options-list",
                    },
                    each(feature.values || [], (option) => {
                        const optPrice =
                            option.final_price || option.price || 0;
                        const hasPrice =
                            feature.has_different_prices && optPrice > 0;
                        return h.div(
                            {
                                class: "d-flex align-items-center justify-content-between py-2 cursor-pointer border-bottom border-light border-opacity-50",
                                listeners: {
                                    click: () => {
                                        updateStateValue(targetState, (sel) => {
                                            if (extraId !== null) {
                                                const extraFeats =
                                                    sel[extraId] || {};
                                                if (type === "single_choice") {
                                                    extraFeats[feature.id] = [
                                                        {
                                                            id: option.id,
                                                            value: option.value,
                                                            final_price:
                                                                optPrice,
                                                            affect_price:
                                                                !!feature.has_different_prices,
                                                            feature_name:
                                                                feature.name,
                                                            discounted_final_price:
                                                                option.discounted_final_price ??
                                                                null,
                                                        },
                                                    ];
                                                } else {
                                                    let list =
                                                        extraFeats[
                                                            feature.id
                                                        ] || [];
                                                    const idx = list.findIndex(
                                                        (x) =>
                                                            x.id === option.id,
                                                    );
                                                    if (idx > -1) {
                                                        list.splice(idx, 1);
                                                    } else {
                                                        list.push({
                                                            id: option.id,
                                                            value: option.value,
                                                            final_price:
                                                                optPrice,
                                                            affect_price:
                                                                !!feature.has_different_prices,
                                                            feature_name:
                                                                feature.name,
                                                            discounted_final_price:
                                                                option.discounted_final_price ??
                                                                null,
                                                        });
                                                    }
                                                    if (list.length === 0) {
                                                        delete extraFeats[
                                                            feature.id
                                                        ];
                                                    } else {
                                                        extraFeats[feature.id] =
                                                            list;
                                                    }
                                                }
                                                sel[extraId] = extraFeats;
                                            } else {
                                                if (type === "single_choice") {
                                                    sel[feature.id] = [
                                                        {
                                                            id: option.id,
                                                            value: option.value,
                                                            final_price:
                                                                optPrice,
                                                            affect_price:
                                                                !!feature.has_different_prices,
                                                            feature_name:
                                                                feature.name,
                                                            discounted_final_price:
                                                                option.discounted_final_price ??
                                                                null,
                                                        },
                                                    ];
                                                } else {
                                                    let list =
                                                        sel[feature.id] || [];
                                                    const idx = list.findIndex(
                                                        (x) =>
                                                            x.id === option.id,
                                                    );
                                                    if (idx > -1) {
                                                        list.splice(idx, 1);
                                                    } else {
                                                        list.push({
                                                            id: option.id,
                                                            value: option.value,
                                                            final_price:
                                                                optPrice,
                                                            affect_price:
                                                                !!feature.has_different_prices,
                                                            feature_name:
                                                                feature.name,
                                                            discounted_final_price:
                                                                option.discounted_final_price ??
                                                                null,
                                                        });
                                                    }
                                                    if (list.length === 0) {
                                                        delete sel[feature.id];
                                                    } else {
                                                        sel[feature.id] = list;
                                                    }
                                                }
                                            }
                                            return sel;
                                        });
                                        this.updateConfigMap(
                                            this.currentProductId,
                                        );
                                    },
                                },
                            },
                            h.label(
                                {
                                    class: "small mb-0 cursor-pointer w-100 text-dark fs-6 d-flex align-items-center justify-content-between",
                                },
                                h.span(option.value),
                                either(hasPrice, () =>
                                    h.span(
                                        {
                                            class: "text-muted small fw-medium",
                                        },
                                        monetary(optPrice, userCurrency),
                                    ),
                                ),
                            ),
                            v(targetState, (selState) => {
                                const sel = selState.value || {};
                                const list =
                                    extraId !== null
                                        ? sel[extraId]?.[feature.id] || []
                                        : sel[feature.id] || [];
                                const isSelected = list.some(
                                    (x) => x.id === option.id,
                                );
                                return h.input(
                                    {
                                        class: "form-check-input ms-2",
                                        type:
                                            type === "single_choice"
                                                ? "radio"
                                                : "checkbox",
                                        name:
                                            extraId !== null
                                                ? `extra-feature-${feature.id}-${option.id}`
                                                : `feature-${feature.id}-${option.id}`,
                                        style: "width: 1.2rem; height: 1.2rem; pointer-events: none;",
                                    },
                                    either(isSelected, { checked: true }),
                                );
                            }),
                        );
                    }),
                );
        }
    }

    cleanUp() {
        if (this.holder) {
            cleanDispose(this.holder);
        }
    }
}

ojs(ViewProduct);
